export interface AuthConsentsPayload {
  terms: boolean;
  privacy: boolean;
  marketing?: boolean;
  analytics?: boolean;
}

export interface RegistrationConsentsFormState {
  termsAccepted: boolean;
  privacyAccepted: boolean;
  marketing: boolean;
  analytics: boolean;
}

export const DEFAULT_REGISTRATION_CONSENTS: RegistrationConsentsFormState = {
  termsAccepted: false,
  privacyAccepted: false,
  marketing: false,
  analytics: false,
};

export function toAuthConsentsPayload(
  state: RegistrationConsentsFormState
): AuthConsentsPayload {
  return {
    terms: state.termsAccepted,
    privacy: state.privacyAccepted,
    ...(state.marketing ? { marketing: true } : {}),
    ...(state.analytics ? { analytics: true } : {}),
  };
}
